import {html, nothing} from '../lib/lit-html.js';
import {classMap} from '../lib/lit/directives/class-map.js';
import {searchPageHeader} from './searchpageheader.js';
import {attributeFilter, attributeFilterSkeleton} from './attributefilter.js';
import {searchPageLoadMore} from './searchpageloadmore.js';
import {searchPageItem} from './searchpageitem.js';
import {showingBar, showingBarSkeleton} from './showingbar.js';
import {SearchResultState} from '../searchresultstate.js';

function hr(){
	return html`<hr
	class="u-margin-horizontal--large"
	style="border-style:solid; border-color: currentColor; opacity: 0.5;">`;
}

function similarSearches(state){
	const queries = state.search.similarQueries;

	if (queries.length === 0){
		return nothing;
	}

	const btnClasses = {
		'ekm-search-page-similar-item': true,
		'shopui-button': true,
		'shopui-button--primary': true,
		'shopui-button--inline': true,
		'shopui-button--medium': true,
		'u-display--inline-block': true,
		'u-margin-right': true,
	};

	return html`
		${hr()}
		<h2>Similar Searches:</h2>
		<div>
			${queries.map(v => {
				const q = v.value || v;
				return html`
					<a class=${classMap(btnClasses)} data-query=${q}>
					${q}
					</a>`;
			})}
		</div>
	`;
}

function alsoViewed(state){
	const {query, similarItems: items} = state.search;

	if (items.length === 0){
		return nothing;
	}

	return html`
		${hr()}
		<h2>Customer who searched for "${query}" also viewed</h2>
		<div class="ekm-search-page-items">
			${items.map(item => searchPageItem(state, item))}
		</div>
	`;
}

function noresults(state){
	return html`
		<div class="ekm-search-page">
			<div class="ekm-search-page-body">
				<div class="ekm-search-page-no-items">
					<h1>Sorry, we couldn't find any results for "${state.search.query}"</h2>
					<p>Try checking your spelling or use more general terms</p>
					<h2>Search Suggestions:</h2>
					<ul>
						<li>Check your spelling</li>
						<li>Use just a few key words instead of a sentence</li>
						<li>Make sure there's a space between words</li>
					</ul>
					${similarSearches(state)}
					${alsoViewed(state)}
				</div>
			</div>
		</div>
	`;
}

function results(state){
	var classes = {
		'filters-visible': state.ui.filtersVisible,
		'grid-view-style': state.ui.gridView,
		'list-view-style': state.ui.listView,
	};

	return html`
		<div class="ekm-search-page">
			${searchPageHeader(state)}
			<div class="ekm-search-page-body ${classMap(classes)}">
				${state.showAttributeFilter ? [attributeFilter(state)] : []}
				${showingBar(state)}
				<div class="ekm-search-page-items">
					${state.search.items.map(item => searchPageItem(state, item))}
				</div>
				${searchPageLoadMore(state)}
			</div>
		</div>
	`;
}

function skeleton(state){
	return html`
		<div class="ekm-search-page skeleton">
			${searchPageHeader(state)}
			<div class="ekm-search-page-body">
				${state.showAttributeFilter ? [attributeFilterSkeleton(state)] : []}
				${showingBarSkeleton(state)}
				<div class="ekm-search-page-items">
					${Array.apply(null, Array(8)).map(() => searchPageItem(
						state, 
						{
							name: '',
							description: '',
							price: 0
						}, 
						true
					))}
				</div>
			</div>
		</div>
	`;
}

function isUsingFilter(state){
	if (Object.keys(state.search.attributes).length > 0) return true;

	if (state.search.price.min != null){
		if (state.search.price.min != state.priceRange.min) return true;
	} 

	if (state.search.price.max != null){
		if (state.search.price.max != state.priceRange.max) return true;
	}

	return false;
}

export function searchPage(state){
	var {
		search: {
			state: rstate,
			totalItems
		}
	} = state;

	if (rstate === SearchResultState.UNLOADED){
		return skeleton(state);
	}

	if (totalItems === 0 && !isUsingFilter(state) && rstate !== SearchResultState.LOADING){
		return noresults(state);
	}

	return results(state);
}